import React from 'react';
import { Package } from '@phosphor-icons/react';

const MyPlanEmptyState = () => (
  <div className="flex flex-col items-center justify-center gap-2 py-16 px-4 text-center text-content">
    <Package size={32} className="text-muted-deep" />
    <p>Todavía no tienes un plan asignado.</p>
    <p className="text-sm text-content-muted">
      Contacta a tu administrador para que gestione la asignación desde el Backoffice.
    </p>
  </div>
);

export default MyPlanEmptyState;
